import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import type { Session, User } from '@supabase/supabase-js';
import { supabase, supabaseConfigured } from '../supabaseClient.ts';

type Role = 'admin' | 'customer' | null;
type AuthValue = {
  loading: boolean; configured: boolean; session: Session | null; user: User | null; role: Role;
  signIn: (email:string,password:string)=>Promise<string|null>; signOut:()=>Promise<void>;
};
const AuthContext=createContext<AuthValue|undefined>(undefined);

export function AuthProvider({children}:{children:React.ReactNode}) {
  const [session,setSession]=useState<Session|null>(null); const [role,setRole]=useState<Role>(null); const [loading,setLoading]=useState(true);
  async function loadRole(s:Session|null){
    if(!supabase || !s?.user){setRole(null);return;}
    const {data,error}=await supabase.from('user_roles').select('role').eq('user_id',s.user.id).maybeSingle();
    if(error){setRole(null);return;} setRole((data?.role as Role) ?? null);
  }
  useEffect(()=>{ if(!supabase){setLoading(false);return;} let mounted=true;
    supabase.auth.getSession().then(async ({data})=>{if(!mounted)return;setSession(data.session);await loadRole(data.session);if(mounted)setLoading(false);});
    const {data:sub}=supabase.auth.onAuthStateChange(async (_e,s)=>{setSession(s);await loadRole(s);setLoading(false);});
    return()=>{mounted=false;sub.subscription.unsubscribe();};
  },[]);
  const value=useMemo<AuthValue>(()=>({loading,configured:supabaseConfigured,session,user:session?.user??null,role,
    signIn:async(email,password)=>{if(!supabase)return 'Supabase is nog niet gekoppeld.';const {error}=await supabase.auth.signInWithPassword({email,password});return error?.message??null;},
    signOut:async()=>{if(supabase)await supabase.auth.signOut();}
  }),[loading,session,role]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
export function useAuth(){const c=useContext(AuthContext);if(!c)throw new Error('useAuth must be inside AuthProvider');return c;}
